import { Identity, ResponseError } from '@ynap/api-utils';
import { timeout } from '@ynap/promise-utils';
import { getCommerceConfig, getClientRequestConfig } from '@ynap/config-state';
import setUberToken from './setUberToken';

export default function createGuestIdentity() {
    return (dispatch, getState, fetch) => {
        const state = getState();
        const watstonConfig = getCommerceConfig(state);

        const guestIdentityRequest = Identity.createGuestIdentity(watstonConfig);

        return timeout(fetch(guestIdentityRequest, { method: 'POST' }), getClientRequestConfig(state).timeout)
            .then((response) => {
                if (!response.ok) {
                    throw new ResponseError(response);
                }

                return response.json();
            })
            .then((json) => dispatch(setUberToken(json.Ubertoken)));
    };
}
